"use client";
import { jsx } from "react/jsx-runtime";
//#region packages/@mantine/core/src/core/factory/factory.tsx
function identity(value) {
	return value;
}
function factory(ui) {
	const Component = ui;
	Component.extend = identity;
	Component.withProps = (fixedProps) => {
		const Extended = (props) => /* @__PURE__ */ jsx(Component, {
			...fixedProps,
			...props
		});
		Extended.extend = Component.extend;
		Extended.displayName = `WithProps(${Component.displayName})`;
		return Extended;
	};
	return Component;
}
function genericFactory(ui) {
	return factory(ui);
}
//#endregion
export { factory, genericFactory, identity };

//# sourceMappingURL=factory.mjs.map